import {
  Card,
  CardContent,
  Grid2,
  Typography,
  Button as MatButton,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";
import moment from "moment";
import { getUser } from "../../../../utils/types";
import { handleDate } from "../../../../shared/CommonFunctions/CommonFunction";

const breadcrumbs: BreadcrumbsModel[] = [
  {
    name: "Query Tracker",
    route: "/admin/query-tracker",
  },
  { name: "View Query" },
];

const QueryTrackerView = () => {
  const navigate = useNavigate();
  const state = useLocation();
  const userData = getUser();
  const roleCode = userData?.roles?.role_code;

  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title="View Query">
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          onClick={() =>
            navigate("/admin/query-tracker", {
              state: {
                queryStatusState: state?.state?.queryStatusState,
                paginationState: state?.state?.paginationState,
              },
            })
          }
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <CardContent sx={{ padding: { xs: 0, md: "16px" } }}>
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }} marginBottom={4}>
              <Typography variant="body1">Query Title</Typography>
              <Typography variant="subtitle2">
                {state?.state?.data?.title || "NA"}
              </Typography>
            </Grid2>
            {roleCode !== "candidate" &&
            (<Grid2 size={{xs: 12, sm: 6, md: 3, lg: 3}} marginBottom={4}>
                  <Typography variant="body1">Candidate Name</Typography>
                  <Typography variant="subtitle2">
                  {state?.state?.data?.user_id ? `${state?.state?.data?.user_id?.first_name || ""} ${state?.state?.data?.user_id?.last_name || ""}` : "NA"}
                  </Typography>
                </Grid2>)}
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }} marginBottom={4}>
              <Typography variant="body1">Position Title</Typography>
              <Typography variant="subtitle2">
                {state?.state?.data?.position_id?.name || "NA"}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }} marginBottom={4}>
              <Typography variant="body1">Date Raised</Typography>
              <Typography variant="subtitle2">
                {handleDate(state?.state?.data?.date_created)}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }} marginBottom={4}>
              <Typography variant="body1">Query Status</Typography>
              <Typography variant="subtitle2">
                {state?.state?.data?.query_status || "NA"}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }} marginBottom={4}>
              <Typography variant="body1">Query Description</Typography>
              <Typography variant="subtitle2">
                {state?.state?.data?.description}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }} marginBottom={4}>
              <Typography variant="body1">Responses List</Typography>
              <Typography variant="subtitle2">
                <MatButton
                  className="view-response"
                  variant="text"
                  sx={{
                    padding: 0,
                    minWidth: 0,
                  }}
                  onClick={() => {
                    navigate(
                      `/admin/query-tracker/respond/${state?.state?.data?.id}/view`, { state: state?.state }
                    );
                  }}
                // disableRipple
                >
                  View
                </MatButton>
              </Typography>
            </Grid2>
            {state?.state?.data?.query_status==='closed' &&
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="body1">Remarks</Typography>
            <Typography variant="subtitle2">
                {state?.state?.data?.remarks || 'NA'}
              </Typography>
            </Grid2>
            }
          </Grid2>
        </CardContent>
      </Card>
    </PageWrapper>
  );
};
export default QueryTrackerView;
